export const MemberFormModel = function () {
  this.firstName = null
  this.lastName = null
  this.email = null
  this.company = null
  this.locale = ''
  this.sendInvitationNow = true
  this.withCustomInvitationMessage = false
  this.customInvitationMessage = ''
  this.askForIdCheck = true
  this.projectManagersAreHidden = false
  this.team = null
}
